import { useLocation, matchPath } from 'react-router-dom';
import { useSidebarData } from 'app-context/sidebar/SidebarDataProvider';
import { ROUTES_MAP } from 'routes/data/Routes';
import NoPermission from 'pages/authentication/no-permission/NoPermission';
import PageNotFound from 'pages/authentication/page-not-found/PageNotFound';

const useFallbackRoute = () => {
  const { sidebarData } = useSidebarData();
  const location = useLocation();

  const allRoutePaths = Object.keys(ROUTES_MAP);
  const pathname = location.pathname;

  const isKnownRoute = allRoutePaths.some((pattern) =>
    matchPath(pattern, pathname)
  );

  const isAllowedRoute =
    Array.isArray(sidebarData?.data) &&
    sidebarData.data.some((r) => matchPath(r.routeTo, pathname));

  if (isKnownRoute && !isAllowedRoute) {
    return <NoPermission />;
  }

  return <PageNotFound />;
};

export default useFallbackRoute;
